require('./stepClientSearch.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { formatText } = require('core/i18n').i18n;

// @utils
import { getDocumentTypes } from 'commonsUtilities/documentTypes';
const { getDocumentLabelByCountry } = require('utilities/typeDocument');

// @componets
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKInput } = require('commonsComponents/OKInput');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const CountrySelector = require ('routes/loginView/countrySelector/countrySelector');

// @constants
const { DEFAULT_ORIGIN_COUNTRY } = require('constants/countries');


class StepSearchClient extends React.Component {
    constructor(props) {
        super(props);
        this.handleChangeDocNumber = this.handleChangeDocNumber.bind(this);
        this.handleSelectCountryType = this.handleSelectCountryType.bind(this);
        this.handleSelectDocType = this.handleSelectDocType.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        
        this.state = {
            documentNumber: '',
            countryType: DEFAULT_ORIGIN_COUNTRY,
            documentType: getDocumentTypes(DEFAULT_ORIGIN_COUNTRY)[0],
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.resetCounter !== nextProps.resetCounter && nextProps.resetCounter) {
            this.handleReset();
        }
    }


    handleChangeDocNumber(event) {
        this.setState({
            documentNumber: event.target.value.trim().toUpperCase()
        });
    }

    handleSelectCountryType(option) {
        this.setState({
            countryType: option.value,
            documentType: getDocumentTypes(option.value)[0],
        });
    }

    handleSelectDocType(option) {
        this.setState({
            documentType: option.value
        });
    }

    handleReset() {
        const { resetErrorMessage } = this.props;
        this.setState({
            documentNumber: '',
            documentType: getDocumentTypes(DEFAULT_ORIGIN_COUNTRY)[0],
        });
        resetErrorMessage();
    }

    handleNextClick() {
        const { handleNext, showEmptyDocumentError, resetErrorMessage } = this.props;
        const { countryType, documentType, documentNumber } = this.state;

        resetErrorMessage();

        if (documentNumber === '') {
            showEmptyDocumentError();
        } else {
            handleNext(documentType, documentNumber, countryType);
        }
    }

    render() {
        // const
        const { immStepSearchClient, stepNo} = this.props;
        const { countryType, documentType, documentNumber } = this.state;

        const loading = immStepSearchClient.get('isFetching');

        const documentTypes = getDocumentTypes(countryType).map(dt => {
            const label = getDocumentLabelByCountry(dt, countryType).label;
            return { value: dt, label: label }
        }, this);

        // copies
        const title = formatText('stepClientSearch-title');
        const labelIdCountry = formatText('stepClientSearch-labelIdCountry');
        const labelIdType = formatText('stepClientSearch-labelIdType');
        const labelIdNumber = formatText('stepClientSearch-labelIdNumber');
        const buttonNextText = formatText('commons-search');
        const resetLinkText = formatText('stepClientSearch-reset');
        const inputDocumentError = immStepSearchClient.get('documentErrorMessage');

        return (
            <section className="step-client-search">
                <div className="step-client-search__header">
                    <span className="wizard-step--vertical__progress-indicator">
                        {stepNo}
                    </span>
                    <h4 className="wizard-step--vertical__title step-client-search__title">
                        {title}
                    </h4>
                </div>

                <div className="step-client-search__body">

                    <div className="step-client-search__id-wrap">
                        <CountrySelector
                            label={labelIdCountry}
                            onHandleChange={this.handleSelectCountryType}
                            selectedCountry={countryType}
                        />
                    </div>

                    <div className="step-client-search__id-wrap">
                        <OKSelect
                            label={labelIdType}
                            name="idDocument"
                            options={documentTypes}
                            value={documentType}
                            onChange={this.handleSelectDocType}
                        />
                    </div>
                    <div className="step-client-search__id-wrap">
                        <OKInput
                            label={labelIdNumber}
                            value={documentNumber}
                            onChange={this.handleChangeDocNumber}
                            errorState={!!inputDocumentError}
                            errorMessage={inputDocumentError}
                        />
                    </div>
                    <div className="step-client-search__id-wrap">
                        <OKButton
                            modifier="link-ghost"
                            onClick={this.handleReset}
                        >
                            {resetLinkText}
                        </OKButton>
                    </div>
                </div>
                <div className="step-client-login__footer">
                    <div className="step-client-login__buttons">
                        <OKButton
                            modifier="secondary"
                            onClick={this.handleNextClick}
                            rightIcon="icon-siguiente"
                            loading={loading}>
                            {buttonNextText}
                        </OKButton>
                    </div>
                </div>
            </section>
        );
    }
}

StepSearchClient.propTypes = {
    immStepSearchClient: PropTypes.object.isRequired,
    stepNo: PropTypes.number.isRequired,
    handleNext: PropTypes.func.isRequired,
    resetCounter: PropTypes.number.isRequired,
    resetErrorMessage: PropTypes.func.isRequired,
    showEmptyDocumentError: PropTypes.func.isRequired,
};

module.exports = StepSearchClient;
